import { combineReducers } from "redux";
import authReducer from "./auth/Auth";
import accountReducer from "./accounts/Account";


const appReducer = combineReducers({
    auth: authReducer,
    account: accountReducer,


});

export default appReducer;
